export default __webpack_public_path__ + "static/media/rarity.2e423edf.gif";